// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2dVz8","toggleArrow":"styles_toggleArrow__115ur","closedArrow":"styles_closedArrow__3-Bya","details":"styles_details__1HKJz","show":"styles_show__3EIJQ"};